// extracted by mini-css-extract-plugin
export default {"message":"_jQExfHU0F"};